import React, { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { PaginaCreacionLibre } from "../../Componentes/Compuestos/Paginas/PaginaCreacionLibre";
import ComboAbmArtArticulos_Reservables from "../../Componentes/Compuestos/Combos/ComboAbmArtArticulos_Reservables";
import { LVForm } from "../../Componentes/Basicos/LVForm";
import { GroupItem, SimpleItem, Label } from "devextreme-react/form";
import { CheckBox, NumberBox } from "devextreme-react";
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion";

export const VEN_Reservas_CambioDeHorariosAforos = () => {

  let Codigo = useParams()

  const { ABM_ART_Articulos_Reservables: { function_ABM_ART_Articulos_Reservables_Leer, function_ABM_ART_Articulos_Reservables_Modificar } } = require('neftis7_apicaller');
  const [codigoArticulo, setCodigoArticulo] = useState(null);

  const [intervaloMinimoMinutos, setIntervaloMinimoMinutos] = useState(0);
  const [lunesDisponible, setLunesDisponible] = useState(false);
  const [lunesCantidadMaxima, setLunesCantidadMaxima] = useState(0);
  const [lunesHoraDesde, setLunesHoraDesde] = useState(0);
  const [lunesHoraHasta, setLunesHoraHasta] = useState(0);
  const [martesDisponible, setMartesDisponible] = useState(false);
  const [martesCantidadMaxima, setMartesCantidadMaxima] = useState(0);
  const [martesHoraDesde, setMartesHoraDesde] = useState(0);
  const [martesHoraHasta, setMartesHoraHasta] = useState(0);
  const [miercolesDisponible, setMiercolesDisponible] = useState(false);
  const [miercolesCantidadMaxima, setMiercolesCantidadMaxima] = useState(0);
  const [miercolesHoraDesde, setMiercolesHoraDesde] = useState(0);
  const [miercolesHoraHasta, setMiercolesHoraHasta] = useState(0);
  const [juevesDisponible, setJuevesDisponible] = useState(false);
  const [juevesCantidadMaxima, setJuevesCantidadMaxima] = useState(0);
  const [juevesHoraDesde, setJuevesHoraDesde] = useState(0);
  const [juevesHoraHasta, setJuevesHoraHasta] = useState(0);
  const [viernesDisponible, setViernesDisponible] = useState(false);
  const [viernesCantidadMaxima, setViernesCantidadMaxima] = useState(0);
  const [viernesHoraDesde, setViernesHoraDesde] = useState(0);
  const [viernesHoraHasta, setViernesHoraHasta] = useState(0);
  const [sabadoDisponible, setSabadoDisponible] = useState(false);
  const [sabadoCantidadMaxima, setSabadoCantidadMaxima] = useState(0);
  const [sabadoHoraDesde, setSabadoHoraDesde] = useState(0);
  const [sabadoHoraHasta, setSabadoHoraHasta] = useState(0);
  const [domingoDisponible, setDomingoDisponible] = useState(false);
  const [domingoCantidadMaxima, setDomingoCantidadMaxima] = useState(0);
  const [domingoHoraDesde, setDomingoHoraDesde] = useState(0);
  const [domingoHoraHasta, setDomingoHoraHasta] = useState(0);
  const [imagen, setImagen] = useState('');
  const [cantidadesVisiblesEnWeb, setCantidadesVisiblesEnWeb] = useState(false);
  const [disponibleWeb, setDisponibleWeb] = useState(false);
  const [sumaParticipantesACodigoArticulo, setSumaParticipantesACodigoArticulo] = useState('');
  const [cierreEnProceso, setCierreEnProceso] = useState(false);


  const onValueChangedIntervaloMinimoMinutos = async (e) => {
    setIntervaloMinimoMinutos(e.value)
  }

  const onValueChangedLunesDisponible = async (e) => {
    setLunesDisponible(e.value)
  }

  const onValueChangedLunesCantidadMaxima = async (e) => {
    setLunesCantidadMaxima(e.value)
  }

  const onValueChangedLunesHoraDesde = async (e) => {
    setLunesHoraDesde(e.value)
  }

  const onValueChangedLunesHoraHasta = async (e) => {
    setLunesHoraHasta(e.value)
  }

  const onValueChangedMartesDisponible = async (e) => {
    setMartesDisponible(e.value)
  }

  const onValueChangedMartesCantidadMaxima = async (e) => {
    setMartesCantidadMaxima(e.value)
  }

  const onValueChangedMartesHoraDesde = async (e) => {
    setMartesHoraDesde(e.value)
  }

  const onValueChangedMartesHoraHasta = async (e) => {
    setMartesHoraHasta(e.value)
  }

  const onValueChangedMiercolesDisponible = async (e) => {
    setMiercolesDisponible(e.value)
  }

  const onValueChangedMiercolesCantidadMaxima = async (e) => {
    setMiercolesCantidadMaxima(e.value)
  }

  const onValueChangedMiercolesHoraDesde = async (e) => {
    setMiercolesHoraDesde(e.value)
  }

  const onValueChangedMiercolesHoraHasta = async (e) => {
    setMiercolesHoraHasta(e.value)
  }

  const onValueChangedJuevesDisponible = async (e) => {
    setJuevesDisponible(e.value)
  }

  const onValueChangedJuevesCantidadMaxima = async (e) => {
    setJuevesCantidadMaxima(e.value)
  }

  const onValueChangedJuevesHoraDesde = async (e) => {
    setJuevesHoraDesde(e.value)
  }

  const onValueChangedJuevesHoraHasta = async (e) => {
    setJuevesHoraHasta(e.value)
  }

  const onValueChangedViernesDisponible = async (e) => {
    setViernesDisponible(e.value)
  }

  const onValueChangedViernesCantidadMaxima = async (e) => {
    setViernesCantidadMaxima(e.value)
  }

  const onValueChangedViernesHoraDesde = async (e) => {
    setViernesHoraDesde(e.value)
  }

  const onValueChangedViernesHoraHasta = async (e) => {
    setViernesHoraHasta(e.value)
  }

  const onValueChangedSabadoDisponible = async (e) => {
    setSabadoDisponible(e.value)
  }

  const onValueChangedSabadoCantidadMaxima = async (e) => {
    setSabadoCantidadMaxima(e.value)
  }

  const onValueChangedSabadoHoraDesde = async (e) => {
    setSabadoHoraDesde(e.value)
  }

  const onValueChangedSabadoHoraHasta = async (e) => {
    setSabadoHoraHasta(e.value)
  }

  const onValueChangedDomingoDisponible = async (e) => {
    setDomingoDisponible(e.value)
  }

  const onValueChangedDomingoCantidadMaxima = async (e) => {
    setDomingoCantidadMaxima(e.value)
  }

  const onValueChangedDomingoHoraDesde = async (e) => {
    setDomingoHoraDesde(e.value)
  }

  const onValueChangedDomingoHoraHasta = async (e) => {
    setDomingoHoraHasta(e.value)
  }

  const onValueChangedImagen = async (e) => {
    setImagen(e.value)
  }

  const onValueChangedCantidadesVisiblesEnWeb = async (e) => {
    setCantidadesVisiblesEnWeb(e.value)
  }

  const onValueChangedDisponibleWeb = async (e) => {
    setDisponibleWeb(e.value)
  }

  const onValueChangedSumaParticipantesACodigoArticulo = async (e) => {
    setSumaParticipantesACodigoArticulo(e.value)
  }

  const onValueChangedCodigoArticulo = async (e) => {
    const Articulo = await function_ABM_ART_Articulos_Reservables_Leer(e.value)

    setCodigoArticulo(e.value)
    setIntervaloMinimoMinutos(Articulo.data[0].IntervaloMinimoMinutos)
    setLunesDisponible(Articulo.data[0].LunesDisponible)
    setLunesCantidadMaxima(Articulo.data[0].LunesCantidadMaxima)
    setLunesHoraDesde(Articulo.data[0].LunesHoraDesde)
    setLunesHoraHasta(Articulo.data[0].LunesHoraHasta)
    setMartesDisponible(Articulo.data[0].MartesDisponible)
    setMartesCantidadMaxima(Articulo.data[0].MartesCantidadMaxima)
    setMartesHoraDesde(Articulo.data[0].MartesHoraDesde)
    setMartesHoraHasta(Articulo.data[0].MartesHoraHasta)
    setMiercolesDisponible(Articulo.data[0].MiercolesDisponible)
    setMiercolesCantidadMaxima(Articulo.data[0].MiercolesCantidadMaxima)
    setMiercolesHoraDesde(Articulo.data[0].MiercolesHoraDesde)
    setMiercolesHoraHasta(Articulo.data[0].MiercolesHoraHasta)
    setJuevesDisponible(Articulo.data[0].JuevesDisponible)
    setJuevesCantidadMaxima(Articulo.data[0].JuevesCantidadMaxima)
    setJuevesHoraDesde(Articulo.data[0].JuevesHoraDesde)
    setJuevesHoraHasta(Articulo.data[0].JuevesHoraHasta)
    setViernesDisponible(Articulo.data[0].ViernesDisponible)
    setViernesCantidadMaxima(Articulo.data[0].ViernesCantidadMaxima)
    setViernesHoraDesde(Articulo.data[0].ViernesHoraDesde)
    setViernesHoraHasta(Articulo.data[0].ViernesHoraHasta)
    setSabadoDisponible(Articulo.data[0].SabadoDisponible)
    setSabadoCantidadMaxima(Articulo.data[0].SabadoCantidadMaxima)
    setSabadoHoraDesde(Articulo.data[0].SabadoHoraDesde)
    setSabadoHoraHasta(Articulo.data[0].SabadoHoraHasta)
    setDomingoDisponible(Articulo.data[0].DomingoDisponible)
    setDomingoCantidadMaxima(Articulo.data[0].DomingoCantidadMaxima)
    setDomingoHoraDesde(Articulo.data[0].DomingoHoraDesde)
    setDomingoHoraHasta(Articulo.data[0].DomingoHoraHasta)
    setImagen(Articulo.data[0].Imagen)
    setCantidadesVisiblesEnWeb(Articulo.data[0].CantidadesVisiblesEnWeb)
    setDisponibleWeb(Articulo.data[0].DisponibleWeb)
    setSumaParticipantesACodigoArticulo(Articulo.data[0].SumaParticipantesACodigoArticulo)
  }


  const onClickGuardar = () => {
    try {
      if (cierreEnProceso) return; // si ya está ejecutando, no hace nada
      setCierreEnProceso(true);

      const guardar = async () => {
        await function_ABM_ART_Articulos_Reservables_Modificar(codigoArticulo, intervaloMinimoMinutos,
          lunesDisponible, lunesCantidadMaxima, lunesHoraDesde, lunesHoraHasta,
          martesDisponible, martesCantidadMaxima, martesHoraDesde, martesHoraHasta,
          miercolesDisponible, miercolesCantidadMaxima, miercolesHoraDesde, miercolesHoraHasta,
          juevesDisponible, juevesCantidadMaxima, juevesHoraDesde, juevesHoraHasta,
          viernesDisponible, viernesCantidadMaxima, viernesHoraDesde, viernesHoraHasta,
          sabadoDisponible, sabadoCantidadMaxima, sabadoHoraDesde, sabadoHoraHasta,
          domingoDisponible, domingoCantidadMaxima, domingoHoraDesde, domingoHoraHasta,
          imagen, cantidadesVisiblesEnWeb, disponibleWeb, sumaParticipantesACodigoArticulo)
      }

      guardar();

      alert("Se han guardado correctamente los parametros");
    } catch (error) {
      alert("Hubo problemas guardando los parametros.");
    } finally {
      setCierreEnProceso(false); // Se habilita el botón de nuevo
    }
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    const codigoCompania = localStorage.getItem("CodigoCompania");
    const codigoEmpresa = localStorage.getItem("CodigoEmpresa");
    const codigoPlanta = localStorage.getItem("CodigoPlanta");
    const idPersona = localStorage.getItem("IdPersona");

    // Verificar valores en localStorage
    if (!user || !codigoCompania || !codigoEmpresa || !codigoPlanta || Number(idPersona) < 1) {
      if (Number(idPersona) === -1 || Number(idPersona) === -2 || Number(idPersona) === -3) {
      } else {
        return <Navigate to={"/Login"} />;
      }
    }
  }, []);

  return (
    <PaginaCreacionLibre
      Titulo="CAMBIO DE HORARIOS Y AFORO"
    >
      <LVForm colCount={2} >
        <SimpleItem colSpan={2}>
          <ComboAbmArtArticulos_Reservables
            value={codigoArticulo}
            ancho={300}
            onValueChanged={onValueChangedCodigoArticulo} />
        </SimpleItem>

        <GroupItem colCount={10} caption={"GENERAL"} >
          <SimpleItem colSpan={3}>
            <CheckBox
              text="ARTÍCULO DISPONIBLE EN WEB"
              value={disponibleWeb}
              onValueChanged={onValueChangedDisponibleWeb}
            />
          </SimpleItem>

          <SimpleItem colSpan={3}>
            <CheckBox
              text="CANTS. DISPONIBLES VISIBLES EN WEB"
              value={cantidadesVisiblesEnWeb}
              onValueChanged={onValueChangedCantidadesVisiblesEnWeb}
            />
          </SimpleItem>

          <SimpleItem colSpan={4}>
            <NumberBox value={intervaloMinimoMinutos}
              onValueChanged={onValueChangedIntervaloMinimoMinutos} />
            <Label text="INTERVALO MÍNIMO (MINUTOS)" />
          </SimpleItem>
        </GroupItem>

        <GroupItem colCount={1} caption={"SUMA PARTICIPANTES A CÓDIGO DE ARTÍCULO"} >
          <SimpleItem >
            <ComboAbmArtArticulos_Reservables
              ancho={300}
              value={sumaParticipantesACodigoArticulo}
              onValueChanged={onValueChangedSumaParticipantesACodigoArticulo} />
          </SimpleItem>
        </GroupItem>

        <GroupItem colCount={4} caption={"LUNES"} >
          <SimpleItem colSpan={1}>
            <CheckBox
              text="DISPONIBLE"
              value={lunesDisponible}
              onValueChanged={onValueChangedLunesDisponible}
            />
          </SimpleItem>

          <SimpleItem colSpan={4}>
            <NumberBox value={lunesCantidadMaxima}
              onValueChanged={onValueChangedLunesCantidadMaxima} />
            <Label text="AFORO" />
          </SimpleItem>

          <SimpleItem colSpan={4}>
            <NumberBox value={lunesHoraDesde}
              onValueChanged={onValueChangedLunesHoraDesde} />
            <Label text="HORA DESDE" />
          </SimpleItem>

          <SimpleItem colSpan={4}>
            <NumberBox value={lunesHoraHasta}
              onValueChanged={onValueChangedLunesHoraHasta} />
            <Label text="HORA HASTA" />
          </SimpleItem>
        </GroupItem>

        <GroupItem colCount={4} caption={"MARTES"} >
          <SimpleItem colSpan={1}>
            <CheckBox
              text="DISPONIBLE"
              value={martesDisponible}
              onValueChanged={onValueChangedMartesDisponible}
            />
          </SimpleItem>

          <SimpleItem colSpan={4}>
            <NumberBox value={martesCantidadMaxima}
              onValueChanged={onValueChangedMartesCantidadMaxima} />
            <Label text="AFORO" />
          </SimpleItem>

          <SimpleItem colSpan={4}>
            <NumberBox value={martesHoraDesde}
              onValueChanged={onValueChangedMartesHoraDesde} />
            <Label text="HORA DESDE" />
          </SimpleItem>

          <SimpleItem colSpan={4}>
            <NumberBox value={martesHoraHasta}
              onValueChanged={onValueChangedMartesHoraHasta} />
            <Label text="HORA HASTA" />
          </SimpleItem>
        </GroupItem>

        <GroupItem colCount={4} caption={"MIÉRCOLES"} >
          <SimpleItem colSpan={1}>
            <CheckBox
              text="DISPONIBLE"
              value={miercolesDisponible}
              onValueChanged={onValueChangedMiercolesDisponible}
            />
          </SimpleItem>

          <SimpleItem colSpan={4}>
            <NumberBox value={miercolesCantidadMaxima}
              onValueChanged={onValueChangedMiercolesCantidadMaxima} />
            <Label text="AFORO" />
          </SimpleItem>

          <SimpleItem colSpan={4}>
            <NumberBox value={miercolesHoraDesde}
              onValueChanged={onValueChangedMiercolesHoraDesde} />
            <Label text="HORA DESDE" />
          </SimpleItem>

          <SimpleItem colSpan={4}>
            <NumberBox value={miercolesHoraHasta}
              onValueChanged={onValueChangedMiercolesHoraHasta} />
            <Label text="HORA HASTA" />
          </SimpleItem>
        </GroupItem>

        <GroupItem colCount={4} caption={"JUEVES"} >
          <SimpleItem colSpan={1}>
            <CheckBox
              text="DISPONIBLE"
              value={juevesDisponible}
              onValueChanged={onValueChangedJuevesDisponible}
            />
          </SimpleItem>

          <SimpleItem colSpan={4}>
            <NumberBox value={juevesCantidadMaxima}
              onValueChanged={onValueChangedJuevesCantidadMaxima} />
            <Label text="AFORO" />
          </SimpleItem>

          <SimpleItem colSpan={4}>
            <NumberBox value={juevesHoraDesde}
              onValueChanged={onValueChangedJuevesHoraDesde} />
            <Label text="HORA DESDE" />
          </SimpleItem>

          <SimpleItem colSpan={4}>
            <NumberBox value={juevesHoraHasta}
              onValueChanged={onValueChangedJuevesHoraHasta} />
            <Label text="HORA HASTA" />
          </SimpleItem>
        </GroupItem>

        <GroupItem colCount={4} caption={"VIERNES"} >
          <SimpleItem colSpan={1}>
            <CheckBox
              text="DISPONIBLE"
              value={viernesDisponible}
              onValueChanged={onValueChangedViernesDisponible}
            />
          </SimpleItem>

          <SimpleItem colSpan={4}>
            <NumberBox value={viernesCantidadMaxima}
              onValueChanged={onValueChangedViernesCantidadMaxima} />
            <Label text="AFORO" />
          </SimpleItem>

          <SimpleItem colSpan={4}>
            <NumberBox value={viernesHoraDesde}
              onValueChanged={onValueChangedViernesHoraDesde} />
            <Label text="HORA DESDE" />
          </SimpleItem>

          <SimpleItem colSpan={4}>
            <NumberBox value={viernesHoraHasta}
              onValueChanged={onValueChangedViernesHoraHasta} />
            <Label text="HORA HASTA" />
          </SimpleItem>
        </GroupItem>

        <GroupItem colCount={4} caption={"SABADO"} >
          <SimpleItem colSpan={1}>
            <CheckBox
              text="DISPONIBLE"
              value={sabadoDisponible}
              onValueChanged={onValueChangedSabadoDisponible}
            />
          </SimpleItem>

          <SimpleItem colSpan={4}>
            <NumberBox value={sabadoCantidadMaxima}
              onValueChanged={onValueChangedSabadoCantidadMaxima} />
            <Label text="AFORO" />
          </SimpleItem>

          <SimpleItem colSpan={4}>
            <NumberBox value={sabadoHoraDesde}
              onValueChanged={onValueChangedSabadoHoraDesde} />
            <Label text="HORA DESDE" />
          </SimpleItem>

          <SimpleItem colSpan={4}>
            <NumberBox value={sabadoHoraHasta}
              onValueChanged={onValueChangedSabadoHoraHasta} />
            <Label text="HORA HASTA" />
          </SimpleItem>
        </GroupItem>

        <GroupItem colCount={4} caption={"DOMINGO"} colSpan={2} >
          <SimpleItem colSpan={1}>
            <CheckBox
              text="DISPONIBLE"
              value={domingoDisponible}
              onValueChanged={onValueChangedDomingoDisponible}
            />
          </SimpleItem>

          <SimpleItem colSpan={4}>
            <NumberBox value={domingoCantidadMaxima}
              onValueChanged={onValueChangedDomingoCantidadMaxima} />
            <Label text="AFORO" />
          </SimpleItem>

          <SimpleItem colSpan={4}>
            <NumberBox value={domingoHoraDesde}
              onValueChanged={onValueChangedDomingoHoraDesde} />
            <Label text="HORA DESDE" />
          </SimpleItem>

          <SimpleItem colSpan={4}>
            <NumberBox value={domingoHoraHasta}
              onValueChanged={onValueChangedDomingoHoraHasta} />
            <Label text="HORA HASTA" />
          </SimpleItem>
        </GroupItem>

        <SimpleItem colSpan={2}>
          <LVButtonAccion
            Disabled={cierreEnProceso} Texto="GUARDAR" Ancho={'100%'} onClick={onClickGuardar} />
        </SimpleItem>

      </LVForm>
    </PaginaCreacionLibre >
  );
}
